import {createSelector} from 'reselect';
import {getSystem, getTravelerFeatures, getTripData} from './store';
import {evaluateExperiment} from '../utils/abacusHelper';
import {
    getArrivedFromExternalSite,
    getHasCookiedGeoString,
    getArrivedFromEmail,
    getArrivedFromFacebook
} from '../utils/travelerSegments';

const getTravelerSegments = createSelector(
    [getSystem, getTravelerFeatures, getTripData],
    (system, travelerFeatures, tripData) => {
        const {referer, hostName, queryParamsOnEntry, cookies, environment} = system;
        const {isLoggedIn} = travelerFeatures;
        const {arrivedWithoutDates} = tripData;

        const arrivedFromEmail = getArrivedFromEmail(queryParamsOnEntry);
        const arrivedFromExternalSite = getArrivedFromExternalSite(referer, hostName, environment);
        const arrivedFromFacebook = getArrivedFromFacebook(queryParamsOnEntry);
        const hasRecentGeoSearch = getHasCookiedGeoString(cookies);
        const coldStartUser =
            arrivedFromExternalSite && !arrivedFromEmail && !isLoggedIn && !hasRecentGeoSearch;

        const travelerSegments = {
            arrivedFromEmail,
            arrivedFromExternalSite,
            arrivedFromFacebook,
            arrivedWithoutDates,
            hasRecentGeoSearch,
            isLoggedIn,
            coldStartUser
        };

        // For users in ha_pdp_defineUserColdStart bucket 0,
        // override the definition of coldStartUser to match the definition of arrivedFromExternalSite
        if (travelerSegments.arrivedFromExternalSite && !travelerSegments.coldStartUser) {
            const inExperiment = evaluateExperiment({
                name: 'ha_pdp_defineUserColdStart',
                variant: 1
            });
            travelerSegments.coldStartUser = inExperiment
                ? travelerSegments.coldStartUser
                : travelerSegments.arrivedFromExternalSite;
        }

        return travelerSegments;
    }
);
const getTravelerSegmentFeatures = createSelector(
    [getTravelerSegments, getTripData],
    (travelerSegments, tripData) => {
        const {
            arrivedFromExternalSite,
            arrivedFromFacebook,
            arrivedWithoutDates,
            coldStartUser,
            hasRecentGeoSearch
        } = travelerSegments;
        const {arriveDateText, departDateText} = tripData;
        const hasDates = arriveDateText && departDateText;

        return {
            showLastSearchedLocation: !arrivedFromExternalSite && hasRecentGeoSearch,
            showTopRecoCarousel: coldStartUser,
            showMidpageRecoCarousel: coldStartUser,
            useExpandedSearchBox: coldStartUser,
            useCheckAvailabilityButton: coldStartUser && arrivedWithoutDates,
            redirectToPinnedSerpOnDateEntry:
                coldStartUser && arrivedWithoutDates && !arrivedFromFacebook && !hasDates
        };
    }
);

export {getTravelerSegments, getTravelerSegmentFeatures};
